import colors from '../../styles/colors'

export type CitiesProps = {
  data: string[]
  search: string
}

export type UnitsListProps = {
  data: [
    {
      id: number
      name: string
    }
  ]
  search: string
}

export type StatisticsProps = {
  units: {
    count: number
    publicCount: number
    privateCount: number
  }
  diagnosticians: {
    count: number
    activeCount: number
    inactiveCount: number
  }
  patients: {
    count: number
    publicCount: number
    privateCount: number
  }
  examinations: {
    count: number
    activeCount: number
    inactiveCount: number
  }
}

export type StatisticsFiltersProps = {
  voivodeship: string | undefined
  city: string | null
  unitId: null | number
  from: string
  to: string
  name: string | null
}

export const selectStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 5,
  }),

  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),

  dropdownIndicator: (base) => ({
    ...base,
    color: colors.light_black,
    '> svg': {
      width: '15px',
      height: '15px',
    },
  }),

  control: (base, state) => ({
    ...base,
    width: '220px',
    height: '57px',
    marginRight: '15px',
    background: state.isDisabled ? '#ebebe4' : colors.white,
  }),

  valueContainer: (base) => ({
    ...base,
    minHeight: '46px',
    display: 'flex',
    maxHeight: '55px',
    overflowY: 'auto',
    fontSize: '11px',
  }),

  placeholder: (base) => ({
    ...base,
    fontSize: '12px',
    color: colors.light_black,
  }),

  singleValue: (base) => ({
    ...base,
    fontSize: '16px',
    color: colors.light_black,
  }),
}
